import customVfs from "./customVfs";
import { ReceiptPb } from "../protobufs/receipt_payload";
import pdfMake from "pdfmake/build/pdfmake";
import { calculateVatRates, formatCurrency, formatDateTime, paymentMethodNames } from "./ReceiptCalculationHelpers";

pdfMake.vfs = customVfs;
pdfMake.fonts = {
    "Roboto Mono": {
        normal: 'Roboto Mono.ttf'
    },
};


export function generateReceiptPdf(receipt: ReceiptPb) {
    const definition = generateReceiptContent(receipt);

    console.log(definition);

    // @ts-expect-error
    pdfMake.createPdf(definition).download(`Kassenbeleg ${receipt.organizationName} ${receipt.receiptNumber}.pdf`);
}


function generateReceiptContent(receipt: ReceiptPb) {
    const vatRates = calculateVatRates(receipt);

    return {
        pageSize: {
            width: 300,
            height: "auto",
        },
        pageMargins: [15, 30, 15, 30],
        content: [
            {
                text: receipt.organizationName,
                style: {
                    alignment: "center",
                    fontSize: 24
                }
            },
            {
                text: `${receipt.organizationStreet} ${receipt.organizationStreetNumber}`,
                style: {
                    alignment: "center",
                }
            },
            {
                text: `${receipt.organizationPostalCode} ${receipt.organizationTown}`,
                style: {
                    alignment: "center",
                },
                margin: [0, 0, 0, 20],
            },
            {
                text: `Datum: ${formatDateTime(receipt.documentStartTimeUnix)}`,
            },
            {
                text: `Vorgangsbeginn: ${formatDateTime(receipt.timeFirstOrderUnix)}`,
            },
            {
                text: `Belegnummer: ${receipt.receiptNumber}`,
            },
            {
                text: `Bedienung: ${receipt.actorName}`,
            },
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: '',
                                border: [false, false, false, true],
                                borderColor: [null, null, null, '#a0a0a0']
                            }
                        ]
                    ]
                },
                margin: [0, 10, 0, 15]
            },
            {
                layout: "noBorders",
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', '*', 'auto', 'auto'],
                    body: [
                        [
                            ' ',
                            'Stk.',
                            'Artikel',
                            {
                                text: 'EPreis',
                                style: { alignment: "right" }
                            },
                            {
                                text: 'GPreis',
                                style: { alignment: "right" }
                            }
                        ],
                        ...receipt.positions.map((p) => [
                            vatRates[p.vat].letter,
                            p.amount,
                            p.title,
                            {
                                text: formatCurrency(p.basePriceCents),
                                style: { alignment: "right" }
                            },
                            {
                                text: formatCurrency(p.grossValueCents),
                                style: { alignment: "right" }
                            },
                        ])
                    ]
                }
            },
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: '',
                                border: [false, false, false, true],
                                borderColor: [null, null, null, '#a0a0a0']
                            }
                        ]
                    ]
                },
                margin: [0, 10, 0, 5]
            },
            {
                text: `Gesamt: ${formatCurrency(receipt.totalGrossValueCents)}`,
                style: {
                    alignment: "right",
                    fontSize: 24
                }
            },
            {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: '',
                                border: [false, false, false, true],
                                borderColor: [null, null, null, '#a0a0a0']
                            }
                        ]
                    ]
                },
                margin: [0, 0, 0, 15]
            },
            {
                layout: "noBorders",
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', 'auto', 'auto'],
                    body: [
                        [
                            ' ',
                            'MwSt.',
                            {
                                text: 'Netto',
                                style: { alignment: "right" }
                            },
                            {
                                text: 'Steuer',
                                style: { alignment: "right" }
                            },
                            {
                                text: 'Brutto',
                                style: { alignment: "right" }
                            },
                        ],
                        ...Object.values(vatRates).map((v) =>
                            [
                                v.letter,
                                v.vat,
                                {
                                    text: formatCurrency(v.netCents),
                                    style: { alignment: "right" }
                                },
                                {
                                    text: formatCurrency(v.taxCents),
                                    style: { alignment: "right" }
                                },
                                {
                                    text: formatCurrency(v.grossCents),
                                    style: { alignment: "right" }
                                },
                            ]
                        ),
                    ]
                },
                margin: [0, 0, 0, 15]
            },
            {
                text: `Zahlungsart: ${paymentMethodNames[receipt.paymentMethod]}`,
            },
            {
                text: `Bezahlt: ${formatCurrency(receipt.payedGrossValueCents)}`,
            },
            receipt.organizationTaxNumber.trim().length > 0 ?
                {
                    text: `Steuerummer: ${receipt.organizationTaxNumber}`,
                } : undefined,
            receipt.organizationTaxIdentificationNumber.trim().length > 0 ?
                {
                    text: `Steuer-IdNr.: ${receipt.organizationTaxIdentificationNumber}`,
                } : undefined,
            {
                qr: receipt.tseQrCodeContent,
                style: {
                    alignment: "center"
                },
                margin: [0, 30, 0, 30],
                fit: 200
            },
            {
                text: "OrderAssist",
                characterSpacing: -2.5,
                style: {
                    fontSize: 33,
                    alignment: "center",
                },
                margin: [0, 0, 0, -5],
            },
            {
                text: "Das Bediensystem für Vereinsveranstaltungen",
                style: {
                    fontSize: 7,
                    alignment: "center"
                },
            },
            {
                text: 'www.order-assist.de',
                link: 'https://www.order-assist.de',
                style: {
                    fontSize: 7,
                    alignment: "center",
                }
            },
        ],
        defaultStyle: {
            fontSize: 10,
            font: "Roboto Mono"
        },
    };
}